import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project" }
const _hoisted_2 = { class: "message" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ProjectEditor = _resolveComponent("ProjectEditor")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Nav),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_back_button),
      _createVNode(_component_ProjectEditor, {
        edit: true,
        orgSlug: _ctx.orgSlug,
        prjSlug: _ctx.prjSlug
      }, null, 8, ["orgSlug", "prjSlug"]),
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "テンプレートPDF", -1)),
      _createVNode(_component_Table, {
        data: _ctx.data,
        headers: _ctx.headers,
        linkCols: _ctx.linkCols,
        newUri: _ctx.newUri,
        newCaption: _ctx.newCaption
      }, null, 8, ["data", "headers", "linkCols", "newUri", "newCaption"])
    ]),
    _createVNode(_component_Dialog, {
      ref: "error",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "title" }, "Error", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.error.message), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.errorClose && _ctx.errorClose(...args)))
          }, "Close")
        ])
      ]),
      _: 1,
      __: [2]
    }, 512)
  ], 64))
}